import { Box, ButtonBase, Stack, Typography } from '@mui/material'

type KpiCardProps = {
  title: string
  value: string
  subtitle: string
  icon: string
  iconColor: string
  ariaLabel: string
  onClick: () => void
}

const KpiCard = ({
  title,
  value,
  subtitle,
  icon,
  iconColor,
  ariaLabel,
  onClick
}: KpiCardProps) => (
  <ButtonBase
    onClick={onClick}
    aria-label={ariaLabel}
    sx={{
      width: '100%',
      minHeight: 128,
      border: '1px solid #EFEFEF',
      borderRadius: '24px',
      backgroundColor: '#FFFFFF',
      p: 2.5,
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'space-between',
      alignItems: 'stretch',
      minWidth: 0,
      textAlign: 'left',
      transition: 'border-color 180ms ease, box-shadow 180ms ease',
      '&:hover': {
        borderColor: '#D7DAEA',
        boxShadow: '0 8px 20px rgba(0, 0, 0, 0.06)'
      },
      '&:focus-visible': {
        outline: '2px solid #2570EB',
        outlineOffset: 2
      }
    }}
  >
    <>
      <Stack direction="row" alignItems="center" justifyContent="space-between" gap={2}>
        <Typography sx={{ color: '#464646', fontSize: 14, fontWeight: 500 }}>
          {title}
        </Typography>
        <Box
          component="span"
          sx={{
            width: 32,
            height: 32,
            borderRadius: '50%',
            backgroundColor: iconColor,
            color: '#FFFFFF',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            flexShrink: 0
          }}
          aria-hidden="true"
        >
          <Box component="i" className={icon} sx={{ fontSize: 13 }} />
        </Box>
      </Stack>

      <Stack gap={0.5}>
        <Typography sx={{ color: '#464646', fontSize: 28, fontWeight: 600, lineHeight: '32px' }}>
          {value}
        </Typography>
        <Typography sx={{ color: '#989898', fontSize: 12, fontWeight: 500 }}>
          {subtitle}
        </Typography>
      </Stack>
    </>
  </ButtonBase>
)

export default KpiCard
